import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { baseURL } from "../api-services/httpService";

export const performLogin = createAsyncThunk('auth/performLogin', async ({ password, email }) => {

    const userInput = {
        email: email,
        password: password
    }

    console.log(userInput);

    const response = await axios.post(`${baseURL}/users/login`, userInput);

    console.log("From slice->", response?.data?.data);

    if (response?.data?.statusCode > 300) {
        throw new Error(response?.data);
    }
    return response.data?.data;
})


export const performRegistration = createAsyncThunk('auth/performRegistration', async ({ fullName, email, username, password }) => {
    const userInput = {
        fullName,
        email,
        username,
        password,
    };

    const response = await axios.post(`${baseURL}/users/register`, userInput);

    console.log("From slice 2->", response?.data?.data);

    if (response.data?.statusCode > 300) {
        throw new Error(response.data);
    }

    return response.data?.data;
});

const initialState = {
    userData: null,
    status: 'idle',
    error: null,
}

const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        logout: (state) => {
            state.userData = null;
            state.status = "idle";
            state.error = null;
        }
    },

    extraReducers: (builder) => {
        builder.addCase(performLogin.pending, (state) => {
            state.status = 'loading';
        }).addCase(performLogin.fulfilled, (state, action) => {
            state.userData = action.payload;
            state.status = 'succeeded';
        }).addCase(performLogin.rejected, (state, action) => {
            state.status = 'failed';
            state.error = action.error.message;
        }).addCase(performRegistration.pending, (state) => {
            state.status = 'loading';
        }).addCase(performRegistration.fulfilled, (state, action) => {
            state.userData = action.payload;
            state.status = 'succeeded';
        }).addCase(performRegistration.rejected, (state, action) => {
            state.status = 'failed';
            state.error = action.error.message;
        });
    }
});


export const { logout } = authSlice.actions;
export default authSlice.reducer;


